"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } } function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkCJISHYH5js = require('./chunk-CJISHYH5.js');var _react = require('react'); var t = _interopRequireWildcard(_react);var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var $=_styled2.default.div`
  z-index: 100;
  user-select: none;
  position: absolute;
  max-width: 290px;
  width: max-content;
  padding: ${e=>e.theme.measurements.spacing(4)};
  border-radius: ${e=>e.theme.measurements.shape(2)};
  background: ${e=>e.$color};
  color: ${e=>e.theme.palette.BASE_ONE};

  &::after {
    content: ' ';
    position: absolute;
    border-width: ${e=>e.theme.measurements.spacing(4)};
    border-style: solid;
  }

  ${e=>e.$placement==="top"?`
      left: 50%;
      top: -${e.theme.measurements.spacing(8)};
      transform: translateX(-50%) translateY(-100%);

      &::after {
        top: 100%;
        left: calc(50% - ${e.theme.measurements.spacing(4)});
        border-color: ${e.$color} transparent transparent transparent;
      }
      `:e.$placement==="top-start"?`
      left: 0%;
      top: -${e.theme.measurements.spacing(8)};
      transform: translateX(0%) translateY(-100%);

      &::after {
        top: 100%;
        left: ${e.theme.measurements.spacing(8)};
        border-color: ${e.$color} transparent transparent transparent;
      }
      `:e.$placement==="top-end"?`
      left: 100%;
      top: -${e.theme.measurements.spacing(8)};
      transform: translateX(-100%) translateY(-100%);

      &::after {
        top: 100%;
        left: calc(100% - ${e.theme.measurements.spacing(8)});
        transform: translateX(-100%);
        border-color: ${e.$color} transparent transparent transparent;
      }
      `:e.$placement==="right"?`
      left: calc(100% + ${e.theme.measurements.spacing(8)});
      top: 50%;
      transform: translateX(0) translateY(-50%);


      &::after {
        top: calc(50% - ${e.theme.measurements.spacing(4)});
        left: -${e.theme.measurements.spacing(8)};
        border-color: transparent ${e.$color} transparent transparent;
      }
      `:e.$placement==="right-start"?`
      top: 0%;
      left: calc(100% + ${e.theme.measurements.spacing(8)});
      transform: translateX(0) translateY(0%);


      &::after {
        top: ${e.theme.measurements.spacing(8)};
        left: -${e.theme.measurements.spacing(8)};
        border-color: transparent ${e.$color} transparent transparent;
      }
      `:e.$placement==="right-end"?`
      left: calc(100% + ${e.theme.measurements.spacing(8)});
      transform: translateX(0) translateY(-100%);


      &::after {
        top: calc(100% - ${e.theme.measurements.spacing(8)});
        left: -${e.theme.measurements.spacing(8)};
        transform: translateY(-100%);
        border-color: transparent ${e.$color} transparent transparent;
      }
      `:e.$placement==="bottom"?`
      left: 50%;
      transform: translateX(-50%) translateY(${e.theme.measurements.spacing(8)});


      &::after {
        top: -${e.theme.measurements.spacing(8)};
        left: calc(50% - ${e.theme.measurements.spacing(4)});
        border-color: transparent transparent ${e.$color} transparent;
      }
      `:e.$placement==="bottom-start"?`
      left: 0%;
      transform: translateX(0%) translateY(${e.theme.measurements.spacing(8)});


      &::after {
        top: -${e.theme.measurements.spacing(8)};
        left: ${e.theme.measurements.spacing(8)};
        border-color: transparent transparent ${e.$color} transparent;
      }
      `:e.$placement==="bottom-end"?`
      left: 100%;
      transform: translateX(-100%) translateY(${e.theme.measurements.spacing(8)});


      &::after {
        top: -${e.theme.measurements.spacing(8)};
        left: calc(100% - ${e.theme.measurements.spacing(8)});
        transform: translateX(-100%);
        border-color: transparent transparent ${e.$color} transparent;
      }
      `:e.$placement==="left"?`
      left: auto;
      top: 50%;
      right: calc(100% + ${e.theme.measurements.spacing(8)});
      transform: translateX(0) translateY(-50%);

      &::after {
        top: calc(50% - ${e.theme.measurements.spacing(4)});
        left: 100%;
        border-color: transparent transparent transparent ${e.$color};
      }
      `:e.$placement==="left-start"?`
      top: 0%;
      right: calc(100% + ${e.theme.measurements.spacing(8)});
      transform: translateX(0) translateY(0);

      &::after {
        top: ${e.theme.measurements.spacing(8)};
        left: 100%;
        border-color: transparent transparent transparent ${e.$color};
      }
      `:e.$placement==="left-end"?`
      top: 100%;
      right: calc(100% + ${e.theme.measurements.spacing(8)});
      transform: translateX(0) translateY(-100%);

      &::after {
        top: calc(100% - ${e.theme.measurements.spacing(8)});
        left: 100%;
        transform: translateY(-100%);
        border-color: transparent transparent transparent ${e.$color};
      }
      `:""}
`,r= exports.a =t.forwardRef((e,n)=>{let{open:s,color:m,placement:l}=t.useContext(_chunkCJISHYH5js.a),{children:c,className:o}=e;return s?_jsxruntime.jsx.call(void 0, $,{ref:n,className:o,$color:m,$placement:l,children:c}):null});r.displayName="PopoverContent";var g=r;exports.a = r; exports.b = g;
